import _extends from '@babel/runtime/helpers/extends';
import React__default, { useContext } from 'react';
import PT from 'prop-types';
import { D as DropdownDivider } from '../../Dropdown/DropdownDivider-DIsxdu90.js';
import { S as SelectOptionGroupContainer, a as StyledSelectOptionGroupHeader } from './SelectOptionGroup.styles-9w44UEjV.js';
import { S as SelectList } from '../SelectList-SGDw-BtH.js';
import { a as SelectOptionGroupDisplayName } from '../utils/displayNames-DWYGtsUp.js';
import { S as SelectListContext } from '../SelectListContext-8rVkHKcx.js';
import { n as noop } from '../../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';

const SelectOptionGroup = ({
  label,
  onClick,
  noWrap,
  /**
   * DEPRECATE IN STORM 4.X: This should only be read from SelectListContext.
   */
  focusedValue,
  /**
   * DEPRECATE IN STORM 4.X: This should only be read from SelectListContext.
   */
  selectedValue,
  ...rest
}) => {
  const {
    selectedValue: selectedValueFromContext,
    focusedValue: focusedValueFromContext,
    noWrap: noWrapFromContext,
    onClick: selectListOnClick,
    afterOnSelect
  } = useContext(SelectListContext);
  return /*#__PURE__*/React__default.createElement(SelectOptionGroupContainer, null, /*#__PURE__*/React__default.createElement(DropdownDivider, null), /*#__PURE__*/React__default.createElement(StyledSelectOptionGroupHeader, null, label), /*#__PURE__*/React__default.createElement(SelectList, _extends({
    onChange: selectListOnClick || onClick
  }, rest, {
    selectedValue: selectedValueFromContext || selectedValue,
    focusedValue: focusedValueFromContext || focusedValue,
    noWrap: noWrapFromContext || noWrap,
    afterOnSelect: afterOnSelect
  })));
};
SelectOptionGroup.displayName = SelectOptionGroupDisplayName;
SelectOptionGroup.propTypes = {
  label: PT.string.isRequired,
  onClick: PT.func
};
SelectOptionGroup.defaultProps = {
  onClick: noop
};

export { SelectOptionGroup as S };
//# sourceMappingURL=SelectOptionGroup-Dcsg7eBy.js.map
